import Vue from 'vue'
// 防止重复点击
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
          // alert(1)
          // console.log(el.disabled)
            if (!el.disabled) {
              // alert(2)
                el.disabled = true
                setTimeout(() => {
                  // alert(3)
                    el.disabled = false
                    // console.log('true')
                },binding.value || 3000)
            }
        })
    }
});

export { preventReClick }



// WEBPACK FOOTER //
// ./src/lib/preventReClick.js